import couponType from './coupon-type'
import coupon from './coupon'
import giftCardType from './gift-card-type'
import giftCard from './gift-card'
import campaign from './campaign'
import promotion from './promotion'

export default {
  name: 'FinancialDiscount',
  path: 'discount',
  meta: {
    label: 'discount',
    auth: 'bonus'
  },
  component: {
    name: 'Discount',
    render(c) {
      return c('router-view')
    }
  },
  children: [couponType, coupon, giftCard, giftCardType, promotion, campaign]
}
